
// Helper to check if file type supports preview
export const supportsPreview = (filetype) => {
  const imageTypes = [
    'image/jpeg',
    'image/jpg',
    'image/png',
    'image/gif',
    'image/webp',
    'image/bmp',
    'image/tiff',
    'image/tif'
  ];
  return imageTypes.includes(filetype?.toLowerCase());
};